import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRemindCircleOutlined = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M8 3.25C6.35938 3.25 4.87188 4.125 4.04063 5.525C3.23125 6.94688 3.23125 8.675 4.04063 10.075C4.87188 11.4969 6.35938 12.35 8 12.35C9.61875 12.35 11.1062 11.4969 11.9375 10.075C12.7469 8.675 12.7469 6.94688 11.9375 5.525C11.1062 4.125 9.61875 3.25 8 3.25ZM8 13.4C5.9875 13.4 4.15 12.35 3.14375 10.6C2.1375 8.87188 2.1375 6.75 3.14375 5C4.15 3.27188 5.9875 2.2 8 2.2C9.99062 2.2 11.8281 3.27188 12.8344 5C13.8406 6.75 13.8406 8.87188 12.8344 10.6C11.8281 12.35 9.99062 13.4 8 13.4ZM10.4719 6.77188L7.67188 9.57188C7.45313 9.79063 7.125 9.79063 6.92813 9.57188L5.52813 8.17188C5.30938 7.975 5.30938 7.64688 5.52813 7.45C5.725 7.23125 6.05313 7.23125 6.27188 7.45L7.3 8.47813L9.72812 6.05C9.925 5.83125 10.2531 5.83125 10.4719 6.05C10.6687 6.24688 10.6687 6.575 10.4719 6.77188Z"
	})
});
const ForwardRef = forwardRef(SvgRemindCircleOutlined);
export default ForwardRef;
